'use client';

import RouteError from '@/shared/components/error/RouteError';

/**
 * Settings Page Error Boundary
 *
 * Catches errors specific to the settings page.
 */
export default function SettingsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteError error={error} reset={reset} />;
}
